import { ExitMeetingPageComponent } from "./exit-meeting-page.component";
export var ExitMeetingPageModule = angular
    .module('exitMeetingPage', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('exitMeeting', {
            url: '/exitMeeting',
            component: ExitMeetingPageComponent.selector,
            data: {
                requireLogin: false
            }
        });
    }
])
    .component(ExitMeetingPageComponent.selector, ExitMeetingPageComponent.component)
    .name;
//# sourceMappingURL=exit-meeting-page.module.js.map